import global from '../core/global';
export const Dropbox = global.Dropbox;
